import { all, call, fork, takeEvery } from 'redux-saga/effects';

import { getIsANTLR } from 'app/lib/betting/betting-entities/reducers/stakes/utils/get-is-antlr';
import {
  SUBSCRIBE_TO_FAVORITES,
  UNSUBSCRIBE_FROM_FAVORITES,
} from 'app/modules/Favorites/actions';
import {
  SUBSCRIBE as INTERESTING_MATCHES_SUBSCRIBE,
  UNSUBSCRIBE as INTERESTING_MATCHES_UNSUBSCRIBE,
} from 'app/modules/LandingPage/InterestingMatches/actions';
import {
  LIVE_TOPIC,
  SUBSCRIBE as LIVE_SUBSCRIBE,
  UNSUBSCRIBE as LIVE_UNSUBSCRIBE,
} from 'app/modules/Live/actions/liveHub';
import {
  PREMATCH_MAIN_LINE_TOPIC,
  SUBSCRIBE as PREMATCH_SUBSCRIBE,
  SUBSCRIBE_TO_PREMATCH_MATCHES,
  UNSUBSCRIBE as PREMATCH_UNSUBSCRIBE,
  UNSUBSCRIBE_FROM_PREMATCH_MATCHES,
} from 'app/modules/Prematch/actions';

import { reconnect } from '../hub';
import { SUBSCRIBE_TO_MATCHES, UNSUBSCRIBE_FROM_MATCHES } from '../redux/actions/subscribe-to-matches';
import { SOCKET_RECONNECT_TRIGGERS } from './constants';
import { hubEventsSaga } from './get-data-from-hub/subscription-events';
import {
  subscriptionsExtSaga,
  subscriptionsFavoritesSaga,
  subscriptionsSaga,
} from './subscriptions';

// ---

export default function* signalRSaga() {
  const isANTLR = getIsANTLR('SignalRSaga');
  // forces signalr to reconnect when the user is logged(in/out).
  yield takeEvery(SOCKET_RECONNECT_TRIGGERS, function* () {
    yield call(reconnect);
  });

  yield all([
    isANTLR
      ? fork(subscriptionsExtSaga, {
        subscribeAction: LIVE_SUBSCRIBE,
        unsubscribeAction: LIVE_UNSUBSCRIBE,
        type: 'MatchGroup', matchGroupName: LIVE_TOPIC, onlyCustomStakeNames: true,
      }) : fork(subscriptionsSaga, {
        subscribeAction: LIVE_SUBSCRIBE,
        unsubscribeAction: LIVE_UNSUBSCRIBE,
      }),

    isANTLR
      ? fork(subscriptionsExtSaga, {
        subscribeAction: PREMATCH_SUBSCRIBE,
        unsubscribeAction: PREMATCH_UNSUBSCRIBE,
        type: 'MatchGroup', matchGroupName: PREMATCH_MAIN_LINE_TOPIC, onlyCustomStakeNames: true,
      }) : fork(subscriptionsSaga, {
        subscribeAction: PREMATCH_SUBSCRIBE,
        unsubscribeAction: PREMATCH_UNSUBSCRIBE,
      }),

    fork(subscriptionsSaga, {
      subscribeAction: INTERESTING_MATCHES_SUBSCRIBE,
      unsubscribeAction: INTERESTING_MATCHES_UNSUBSCRIBE,
    }),

    fork(subscriptionsExtSaga, {
      subscribeAction: SUBSCRIBE_TO_PREMATCH_MATCHES,
      unsubscribeAction: UNSUBSCRIBE_FROM_PREMATCH_MATCHES,
      type: 'Match', onlyCustomStakeNames: isANTLR,
    }),

    fork(subscriptionsExtSaga, {
      subscribeAction: SUBSCRIBE_TO_MATCHES,
      unsubscribeAction: UNSUBSCRIBE_FROM_MATCHES,
      type: 'Match',
    }),

    fork(subscriptionsFavoritesSaga, {
      subscribeAction: SUBSCRIBE_TO_FAVORITES,
      unsubscribeAction: UNSUBSCRIBE_FROM_FAVORITES,
    }),

    fork(hubEventsSaga),
  ]);
}
